import { createApp, h } from 'vue'
import { App as InertiaApp, plugin as InertiaPlugin } from '@inertiajs/inertia-vue3'
import { InertiaProgress } from '@inertiajs/progress'
import apolloProvider from './apolloProvider'
import * as Sentry from "@sentry/vue"
import { Integrations } from "@sentry/tracing"

const el = document.getElementById('app');

export const app = createApp({
  render: () =>
    h(InertiaApp, {
      initialPage: JSON.parse(el.dataset.page),
      resolveComponent: (name) => require(`./Pages/${name}`).default,
    }),
  })
  .use(apolloProvider)
  .mixin({ methods: { route } })

InertiaProgress.init({ color: '#000' });

const SENTRY_RELEASE = process.env.VUE_APP_SENTRY_RELEASE
const env = SENTRY_CLIENT_ENV
const dsn = SENTRY_CLIENT_DSN

if (dsn && env !== 'local') {
  Sentry.init({
    app,
    dsn: dsn,
    environment: env,
    release: SENTRY_RELEASE,
    debug: env === 'staging' || env === 'local',
    integrations: [
      new Integrations.BrowserTracing({
        tracingOrigins: ["localhost", "kundenportal.backbord.de", "backbord-b2b.test", "backbord-b2b.soon.live", /^\//],
      }),
    ],
    // Set tracesSampleRate to 1.0 to capture 100%
    // of transactions for performance monitoring.
    // We recommend adjusting this value in production
    tracesSampleRate: env === 'staging' ? 1.0 : 0.2, // Be sure to lower this in production
  })
}
app.config.unwrapInjectedRef = true

app.use(InertiaPlugin).mount(el)
// app.config.devtools = true
